import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  createDashboardID,
  fetchDashboardID,
  FetchModelBlocks,
  getDashboard,
  resetDashboardSliceV2,
} from 'redux/DashboardSliceV2';
import { getBlocks } from 'redux/ModelsSlice';
import { AppDispatch } from 'utils/GlobalHelpers';

const useDashboardData = ({ enable = false }: { enable?: boolean }) => {
  const model = useSelector(getBlocks);
  const dashboard = useSelector(getDashboard);
  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    return () => {
      if (enable && dashboard?.id) dispatch(resetDashboardSliceV2());
    };
  }, [dispatch, enable]);

  useEffect(() => {
    if (model.id && enable) {
      dispatch(FetchModelBlocks({ modelId: Number(model.id) }));
    }
  }, [model.id]);

  useEffect(() => {
    if (model?.id && !dashboard?.id && enable) {
      const yr = new Date(model?.time_properties?.starting_period).getUTCFullYear().toString();
      const fiscalStart = `${model?.time_properties?.fy_start_month}-${yr[2]}${yr[3]}`;
      const emptyDashboardBody = {
        name: 'Dashboard',
        model_id: Number(model.id),
        start_time:
          model?.time_properties?.time_granularity === 'M' ? fiscalStart : `Jan-${yr[2]}${yr[3]}`,
        description: '',
      };

      const createEmptyDashboard = () => {
        dispatch(createDashboardID({ request_body: emptyDashboardBody }));
      };

      const loadDashboard = (retriesLeft: number) => {
        dispatch(fetchDashboardID({ model_id: model.id }))
          .then((response) => {
            if (response.payload?.id) {
              return;
            }
            // Model copy may still be writing the dashboard to blox-bi; retry before creating a shell.
            if (retriesLeft > 0) {
              window.setTimeout(() => loadDashboard(retriesLeft - 1), 1500);
              return;
            }
            createEmptyDashboard();
          })
          .catch(() => {
            if (retriesLeft > 0) {
              window.setTimeout(() => loadDashboard(retriesLeft - 1), 1500);
              return;
            }
            createEmptyDashboard();
          });
      };

      loadDashboard(3);
    }
  }, [model?.id, enable]);
};

export default useDashboardData;
